import React,{useEffect, useRef} from "react"
import { Dropdown,InputDefault } from "../../../../components/ui"
import { FieldArray, useFormik, FormikProvider } from 'formik';
import { useQuery } from "react-query";
import { getAllListMember, getListMember } from "../../../../modules/services/member.service";
import { getListProducts } from "../../../../modules/services/product.service";
import { TransactionsSchema } from "../../../../modules/helperValidation";




interface Props {
    handleChange: (e: any) => void
    id? : string
    initLoad? : any
    loadings?: any
}

const FormTransactions : React.FC <Props> = ({handleChange, id, initLoad, loadings}) => {
    const resetForms = useRef<any>(null)
    const TypeMaster = [
      { label: 'Approved', value: 'approve' },
      { label: 'Reject', value: 'reject' },
      { label: 'On-Process', value: 'on-process' },
    ]

    const { data: dataMembers, isLoading  } = useQuery(['getMember'], async () => await getAllListMember() )
    const { data: dataProduct,  isLoading : loadingProduct  } = useQuery(['getProduct'], async () => await getListProducts())
    const datasProduct = dataProduct ?? []
    const initValue ={
      date: '',
      invoiceId: '',
      detailTransactions: [{
        ProductId:'',
        Qty:''
      }],
      status: '',
      MemberId: '',
  }
    const formik = useFormik({
        initialValues : id ? initLoad : initValue ,
        onSubmit: (values, {resetForm}) => {
           handleChange(values)
        },
        enableReinitialize: true,
        validationSchema:TransactionsSchema
    })

    return(
      <FormikProvider value={formik}>
      <form id="form-reward-detail" onSubmit={formik.handleSubmit} ref={resetForms}>
          <div className='d-flex flex-column align-items-center gap-4'>
              <div className='mb-3 w-100'>
                <label htmlFor='date' className='form-label'>
                 Date
                </label>
                <InputDefault type='date' id='date' name="date" onChange={formik.handleChange} value={formik.values.date } validation={formik.errors.date && formik.touched.date }  textError={formik.errors.date}     />
                <label htmlFor='invoiceId' className='form-label'>
                  Transaction ID
                </label>
                <InputDefault type='text' id='invoiceId' name="invoiceId" onChange={formik.handleChange} value={formik.values.invoiceId } validation={formik.errors.invoiceId && formik.touched.invoiceId }  textError={formik.errors.invoiceId}   />
                <FieldArray 
                    name="detailTransactions" 
                    render={(arrayHelpers) => (
                          <div >
                            {formik.values.detailTransactions.map((e: any,i: any) => (
                                  <div className='col-lg-9' key={i}>
                                  <div className='row'>
                                    <div className='col-lg-6 fv-row'>
                                      <label htmlFor='id'className='form-label '>
                                        Product
                                      </label>
                                      <Dropdown  name={`detailTransactions[${i}].ProductId`} id={`detailTransactions[${i}].ProductId`} data={datasProduct}   onChanges={formik.handleChange} value={formik.values.detailTransactions[i].ProductId}/>
                                    </div> 
                                    <div className='col-lg-6 fv-row'>
                                      <label htmlFor='Qty' className='form-label'>,
                                        Qty
                                      </label>
                                      <InputDefault type='number' id={`detailTransactions[${i}].Qty`} name={`detailTransactions.[${i}].Qty`} onChange={formik.handleChange} value={formik.values.detailTransactions[i].Qty} />
                            
                                    </div>
                                    <div className='col-lg-6 fv-row'>
                                    {i != 0 && <button
                                      className='btn btn-danger'
                                      type="button"   
                                      onClick={() => arrayHelpers.remove(i)}        
                                    >
                                     -
                                    </button>} 
                                    </div>
                                    
                                  </div>
                                </div>
                            ))}
                            <button
                              className='btn btn-success my-2'
                              onClick={() => arrayHelpers.push({ProductId: "", Qty: ""})}  
                              type="button"     
                            >
                              +
                            </button>
                          </div>
                    )}
                   />
                
                <label htmlFor='MemberId' className='form-label'>
                  Member
                </label>
                <Dropdown  id={'MemberId'} data={dataMembers} onChanges={formik.handleChange}   value={formik.values.MemberId }   />
                <label htmlFor='status' className='form-label'>
                  Status
                </label>
                <Dropdown  id={'status'} data={TypeMaster} onChanges={formik.handleChange}  value={formik.values.status}    />
                <div className='card-footer d-flex justify-content-end py-6 px-9'>
                {!loadings ?  <button
                     className='btn btn-primary'
                     data-bs-target='#add-edit-member'
                     type="submit"
                   >
                      Submit
                  </button> :  <button
                     className='btn btn-primary'
                     data-kt-indicator="on"
                     type="button"
                   >
                     <span className="indicator-progress">Please wait... 
                     <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span>
                  </button> }
                 </div>
              </div>
          </div>
      </form>
      </FormikProvider>
    )
}

export default FormTransactions